/* scenes-hydrate 1785087577 */
/* nazifa-storefront v8.1785087146 — hero cycle */
(() => {
  if (window.__NAZIFA_STOREFRONT_V8__) return;
  window.__NAZIFA_STOREFRONT_V8__ = true;
  window.__NAZIFA_STOREFRONT__ = true;

  const ensureCss = () => {
    if (document.querySelector('link[data-nazifa-5173], link[href*="nazifa-atelier.css"]')) return;
    const from = document.querySelector('script[src*="nazifa-storefront.js"], script[src*="section-hydration.js"], script[src*="accordion-custom.js"]');
    let href = "/cdn/shop/t/18/assets/nazifa-atelier.css";
    if (from && from.src) {
      href = from.src.replace(/[^/]+\.js[^/]*$/, "nazifa-atelier.css");
    }
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href.startsWith("http") || href.startsWith("//") ? (href.startsWith("//") ? `https:${href}` : href) : href;
    link.dataset.nazifa5173 = "1";
    document.head.appendChild(link);
  };

  const ensureScript = (needle) =>
    new Promise((resolve) => {
      if (document.querySelector(`script[src*="${needle}"]`)) return resolve();
      const probe = document.querySelector('script[src*="/assets/"]');
      let src = `/cdn/shop/t/18/assets/${needle}`;
      if (probe && probe.src) src = probe.src.replace(/[^/]+\.js[^/]*$/, needle);
      const s = document.createElement("script");
      s.src = src.startsWith("//") ? `https:${src}` : src;
      s.defer = true;
      s.onload = () => resolve();
      s.onerror = () => resolve();
      document.body.appendChild(s);
    });

  const FOOTER_LINKS = [
    ["Home", "/"],
    ["Shop", "/collections/all"],
    ["Sumruh", "/collections/sumruh"],
    ["Kuyax", "/collections/kuyax"],
    ["Badam", "/collections/badam"],
    ["Anar", "/collections/anar"],
    ["Size guide", "/pages/size-guide"],
    ["Craft & care", "/pages/craft-and-care"],
    ["Shipping & returns", "/pages/shipping-and-returns"],
    ["Help & FAQ", "/pages/faq"],
    ["About", "/pages/about"],
    ["Trade", "/pages/trade"],
    ["Contact", "/pages/contact"],
  ];

  function injectFooter() {
    if (document.querySelector("[data-nz-footer-inject]")) return;
    if (document.querySelector('a[href="/pages/craft-and-care"]')) return;
    const footer = document.querySelector("footer") || document.querySelector("#footer-group") || document.body;
    const wrap = document.createElement("div");
    wrap.className = "nz-wrap nz-footer-inject";
    wrap.dataset.nzFooterInject = "1";
    wrap.innerHTML = `
      <div><strong>Nazifa</strong>
        ${FOOTER_LINKS.slice(0, 6)
          .map(([l, h]) => `<a href="${h}">${l}</a>`)
          .join("")}
      </div>
      <div><strong>Help</strong>
        ${FOOTER_LINKS.slice(6, 10)
          .map(([l, h]) => `<a href="${h}">${l}</a>`)
          .join("")}
      </div>
      <div><strong>Company</strong>
        ${FOOTER_LINKS.slice(10)
          .map(([l, h]) => `<a href="${h}">${l}</a>`)
          .join("")}
        <p style="opacity:.7;margin:.75rem 0 0">Instagram @nazifa.store</p>
      </div>`;
    footer.appendChild(wrap);
  }

  async function fetchSection(sectionId) {
    const res = await fetch(`/?section_id=${encodeURIComponent(sectionId)}`, {
      headers: { Accept: "text/html" },
      credentials: "same-origin",
    });
    return res.text();
  }

  async function bootHome5173() {
    const main = document.getElementById("MainContent");
    if (!main) return;
    const template = main.getAttribute("data-template") || "";
    if (template && template !== "index") return;

    const existing = main.querySelector("[data-nz-home-5173]");
    const hasCycle = existing && existing.querySelector("[data-nz-hero-cycle] .nz-hero__slide");
    if (hasCycle) return;

    try {
      const html = await fetchSection("nazifa-home-atelier");
      if (!html.includes("data-nz-home-5173") || !html.includes("nz-hero__slide")) return;
      const wrap = document.createElement("div");
      wrap.innerHTML = html.trim();
      const next = wrap.firstElementChild;
      if (!next) return;

      const homeSec =
        existing?.closest("[id^='shopify-section-']") ||
        main.querySelector("[id*='__nazifa_home_atelier']") ||
        main.querySelector("[id*='__hero']");
      const featured = main.querySelector("[id*='__featured_products']");
      const cta = main.querySelector("[id*='__home_cta']");
      if (homeSec) homeSec.replaceWith(next);
      else main.insertBefore(next, main.firstChild);
      featured?.remove();
      cta?.remove();
    } catch (_) {
      /* keep existing hero */
    }
  }

  async function bootHomeShopper() {
    const main = document.getElementById("MainContent");
    if (!main) return;
    const template = main.getAttribute("data-template") || "";
    if (template && template !== "index") return;
    if (main.querySelector("[data-nazifa-shopper]")) return;

    const stale =
      main.querySelector("[id*='__featured_products']") ||
      main.querySelector("[id*='__home_packages_shopper']") ||
      main.querySelector("[data-testid='product-list']")?.closest("[id^='shopify-section-']") ||
      main.querySelector(".ui-test-product-list")?.closest("[id^='shopify-section-']");

    try {
      const secHtml = await fetchSection("nazifa-packages-shopper");
      if (secHtml.includes("data-nazifa-shopper")) {
        const wrap = document.createElement("div");
        wrap.innerHTML = secHtml.trim();
        const next = wrap.firstElementChild;
        if (next) {
          if (stale) stale.replaceWith(next);
          else {
            const home = main.querySelector("[data-nz-home-5173]")?.closest("[id^='shopify-section-']");
            if (home) home.after(next);
            else main.appendChild(next);
          }
          await ensureScript("nazifa-sku-specs.js");
          await ensureScript("nazifa-series-shopper.js");
          return;
        }
      }
    } catch (_) {
      /* fall through */
    }

    if (!stale) return;
    try {
      const html = await fetch("/collections/sumruh", {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
      }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, "text/html");
      const next =
        doc.querySelector("[id*='__packages_shopper']") ||
        doc.querySelector("[id*='__series_shopper']") ||
        doc.querySelector("[data-nazifa-shopper]")?.closest("[id^='shopify-section-']");
      if (!next || !next.querySelector("[data-nazifa-shopper]")) return;
      stale.replaceWith(next);
      await ensureScript("nazifa-sku-specs.js");
      await ensureScript("nazifa-series-shopper.js");
    } catch (_) {
      /* keep grid */
    }
  }

  function bootPdpFacts() {
    const main = document.getElementById("MainContent");
    if (!main) return;
    const template = main.getAttribute("data-template") || "";
    if (!template.includes("product")) return;
    if (document.querySelector("[data-nz-pdp-facts]")) return;

    const skuEl =
      document.querySelector(".product-sku, [data-product-sku], .product__sku") ||
      document.querySelector('variant-picker [selected], [name="id"]');
    let sku = "";
    const skuText = document.body.innerText.match(/\bJX[A-Za-z0-9._-]{2,}\b/);
    if (skuText) sku = skuText[0];

    const apply = (code) => {
      const map = window.NAZIFA_SKU_SPECS || {};
      const s = map[code] || map[code?.toUpperCase?.()] || map[code?.toLowerCase?.()];
      if (!s) return;
      const host =
        document.querySelector(".product-information, .product-details, product-info, .product__info") ||
        main.querySelector("form[action*='/cart/add']")?.parentElement ||
        main;
      const box = document.createElement("div");
      box.className = "nz-pdp-facts";
      box.dataset.nzPdpFacts = "1";
      const yn = (v) => (v === true ? "Yes" : v === false ? "No / confirm SKU" : "");
      const rows = [
        ["Series", s.series],
        ["Size", s.dimensions && s.dimensions !== "/" ? s.dimensions : ""],
        ["Pack", s.pack && s.pack !== "/" ? s.pack : ""],
        ["Craft", s.craft],
        ["Material", s.material || "Ceramic"],
        ["Microwave", yn(s.microwave)],
        ["Oven", yn(s.oven)],
        ["Dishwasher", yn(s.dishwasher)],
      ].filter(([, v]) => v);
      box.innerHTML =
        `<h3>Product facts</h3><dl>` +
        rows.map(([k, v]) => `<div><dt>${k}</dt><dd>${v}</dd></div>`).join("") +
        `</dl>` +
        (s.care_note ? `<p class="nz-muted" style="margin-top:.75rem">${s.care_note}</p>` : "");
      host.appendChild(box);
    };

    ensureScript("nazifa-sku-specs.js").then(() => {
      if (sku) apply(sku);
      document.addEventListener("change", (e) => {
        const t = e.target;
        if (!(t instanceof HTMLSelectElement) && !(t instanceof HTMLInputElement)) return;
        window.setTimeout(() => {
          const again = document.body.innerText.match(/\bJX[A-Za-z0-9._-]{2,}\b/);
          if (again) {
            document.querySelector("[data-nz-pdp-facts]")?.remove();
            apply(again[0]);
          }
        }, 120);
      });
    });
  }

  function hideStaleShopNazifaHeading() {
    document.querySelectorAll("h2, h3, .h2").forEach((el) => {
      if ((el.textContent || "").trim() === "Shop Nazifa" && el.closest("[data-nazifa-shopper]")) {
        /* keep */
      }
    });
  }

  function bootHeroCycle(root) {
    const hero = (root || document).querySelector("[data-nz-hero-cycle]");
    if (!hero || hero.dataset.nzCycling === "1") return;
    hero.dataset.nzCycling = "1";
    const slides = [...hero.querySelectorAll(".nz-hero__slide")];
    if (slides.length < 2) return;
    const seriesEl = hero.querySelector("[data-nz-hero-series]");
    const cta = hero.querySelector("[data-nz-hero-cta]");
    const dotsWrap = hero.querySelector("[data-nz-hero-dots]");
    let idx = 0;
    let timer;
    slides.forEach((slide, i) => {
      slide.setAttribute("role", "link");
      slide.setAttribute("tabindex", "0");
      slide.style.cursor = "pointer";
      const label = slide.dataset.series || `Series ${i + 1}`;
      slide.setAttribute("aria-label", `Open ${label} collection`);
      const open = () => {
        const href = slide.dataset.href;
        if (href) window.location.href = href;
      };
      slide.addEventListener("click", (e) => {
        e.preventDefault();
        go(i, true);
        open();
      });
      slide.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          go(i, true);
          open();
        }
      });
      const b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", `Show ${label} scene`);
      if (i === 0) b.classList.add("is-active");
      b.addEventListener("click", (e) => {
        e.stopPropagation();
        go(i, true);
      });
      dotsWrap?.appendChild(b);
    });
    const dots = dotsWrap ? [...dotsWrap.querySelectorAll("button")] : [];
    function go(n, user) {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle("is-active", i === idx));
      dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
      const active = slides[idx];
      if (seriesEl) seriesEl.textContent = active.dataset.series || "Nazifa";
      if (cta && active.dataset.href) cta.setAttribute("href", active.dataset.href);
      if (user) restart();
    }
    function restart() {
      window.clearInterval(timer);
      timer = window.setInterval(() => go(idx + 1), 3800);
    }
    restart();
  }

  ensureCss();
  const ready = () => {
    injectFooter();
    bootHome5173()
      .then(() => {
        bootHeroCycle(document);
        return bootHomeShopper();
      })
      .then(hideStaleShopNazifaHeading);
    bootHeroCycle(document);
    bootPdpFacts();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }
})();
